import Eyebrow from './Eyebrow';
import Squiggle from './Squiggle';
import { trackEvent } from '../../lib/analytics';

const MAPS_URL = 'https://maps.app.goo.gl/T6cABrSAyGHhRXkY6';
const WAZE_URL = 'https://waze.com/ul?q=Groupe+Scolaire+Sanaa+Casablanca&navigate=yes';
const MAP_EMBED = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3324.833038838069!2d-7.683347011334203!3d33.55771403247783!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda62cb35a9423f9%3A0x6d9a6ffc6d2b8ce0!2sGroupe%20Scolaire%20Sanaa!5e0!3m2!1sfr!2sma!4v1747925850595!5m2!1sfr!2sma';

const trackOutbound = (target: string) =>
  trackEvent('outbound_click', { target, page: 'jpo-portes-ouvertes' });

const Location = () => (
  <section className="location" id="acces">
    <div className="container">
      <div className="location-card">
        <div className="location-info">
          <Eyebrow>Comment s'y rendre</Eyebrow>
          <h2 className="location-title">
            Au cœur d'Oulfa,
            <br />
            <span className="location-title-emph">
              facile d'accès.
              <Squiggle className="title-squiggle" />
            </span>
          </h2>
          <div className="location-address">
            <span className="location-pin" aria-hidden="true">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </span>
            <div>
              <p className="location-line-1">364 boulevard Oum Rabia</p>
              <p className="location-line-2">Oulfa, Casablanca · 20220</p>
            </div>
          </div>
          <div className="location-actions">
            <a
              href={MAPS_URL}
              onClick={() => trackOutbound('maps')}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary location-btn"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              Itinéraire Google Maps
            </a>
            <a
              href={WAZE_URL}
              onClick={() => trackOutbound('waze')}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-ghost location-btn"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <circle cx="12" cy="11" r="9" />
                <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                <circle cx="9" cy="10" r=".5" fill="currentColor" />
                <circle cx="15" cy="10" r=".5" fill="currentColor" />
                <path d="M5 20l1-2M19 20l-1-2" />
              </svg>
              Ouvrir dans Waze
            </a>
          </div>
          <p className="location-meta">
            Stationnement disponible · Accessible en transports en commun
          </p>
        </div>

        <a
          href={MAPS_URL}
          onClick={() => trackOutbound('maps-embed')}
          target="_blank"
          rel="noopener noreferrer"
          className="location-map"
          aria-label="Voir l'école sur Google Maps"
        >
          <iframe
            src={MAP_EMBED}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Plan d'accès — Groupe Scolaire Sanaa"
            allowFullScreen
          />
          <span className="location-map-overlay">
            <span className="location-map-pill">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
              Ouvrir dans Maps
            </span>
          </span>
        </a>
      </div>
    </div>
  </section>
);

export default Location;
